import LegendPage from "../pages/legend"

export const element = <LegendPage />